import { Dispatch } from 'redux';
import { ApiQuestion } from 'src/http';
import { questionActions } from 'src/slices/question-slice';
import { isEmpty } from 'lodash';

const {
  setQuestionRequestStart,
  setQuestionRequestSuccess,
  setQuestionRequestFailure,
  setQuestionRequestDefault,

  setQuestionListRequest,
  setQuestionListSuccess,
  setQuestionListFailure,

  setQuestionRequest,
  setQuestionSuccess,
  setQuestionFailure,
  setQuestionDefault,

  setQuestionCategoriesRequest,
  setQuestionCategoriesSuccess,
  setQuestionCategoriesFailure,

  setQuestionDifficultyLevelsRequest,
  setQuestionDifficultyLevelsSuccess,
  setQuestionDifficultyLevelsFailure,

  setQuestionFieldsRequest,
  setQuestionFieldsSuccess,
  setQuestionFieldsFailure,
} = questionActions;

//List
export const getQuestionList = (params: Record<string, any>) => async (dispatch: Dispatch) => {
  dispatch(setQuestionListRequest());
  try {
    const data = await ApiQuestion.fetchAll(params);
    dispatch(setQuestionListSuccess(data));
  } catch (error) {
    dispatch(setQuestionListFailure(error));
  }
};

export const getQuestion = (id: string | number) => async (dispatch: Dispatch) => {
  dispatch(setQuestionRequest());
  try {
    const data = await ApiQuestion.fetchOne(id);
    dispatch(setQuestionSuccess(data));
  } catch (error) {
    dispatch(setQuestionFailure(error));
  }
};

export const addQuestion = (params: Record<string, any>) => async (dispatch: Dispatch) => {
  dispatch(setQuestionRequest());
  try {
    const data = await ApiQuestion.createOne(params);
    dispatch(setQuestionSuccess(data));
  } catch (error) {
    dispatch(setQuestionFailure(error));
  }
};

export const uploadQuestions = (params: Record<string, any>) => async (dispatch: Dispatch) => {
  dispatch(setQuestionRequestStart());
  return new Promise((resolve, reject) => {
    ApiQuestion.upload(params)
      .then((res) => {
        dispatch(setQuestionRequestSuccess());
        resolve(res);
      })
      .catch((res) => {
        dispatch(setQuestionRequestFailure(res));
        reject(res);
      });
  });
};

export const updateQuestion =
  (id: string | number, params: Record<string, any>) => async (dispatch: Dispatch) => {
    dispatch(setQuestionRequestStart());
    try {
      await ApiQuestion.updateOne(id, params);
      dispatch(setQuestionRequestSuccess());
    } catch (error) {
      dispatch(setQuestionRequestFailure(error));
    }
  };

export const deleteQuestion = (id: string | number) => async (dispatch: Dispatch) => {
  dispatch(setQuestionRequestStart());
  try {
    await ApiQuestion.deleteOne(id);
    dispatch(setQuestionRequestSuccess());
  } catch (error) {
    dispatch(setQuestionRequestFailure(error));
  }
};

export const clearQuestionRequest = () => async (dispatch: Dispatch) => {
  dispatch(setQuestionRequestDefault());
};

export const clearQuestion = () => async (dispatch: Dispatch) => {
  dispatch(setQuestionDefault());
};

export const forceGetQuestionCategories = () => async (dispatch: Dispatch<any>) => {
  dispatch(setQuestionCategoriesRequest());
  try {
    const data = await ApiQuestion.fetchCategories();
    dispatch(setQuestionCategoriesSuccess(data));
  } catch ({ message }) {
    dispatch(setQuestionCategoriesFailure({ message }));
  }
};
export const getQuestionCategories = () => async (dispatch: Dispatch<any>, getState: any) => {
  const storeStates = getState();
  const { categories } = storeStates.question;
  if (isEmpty(categories.hits) && !categories.isLoading) {
    dispatch(forceGetQuestionCategories());
  }
};

export const forceGetQuestionDifficultyLevels = () => async (dispatch: Dispatch<any>) => {
  dispatch(setQuestionDifficultyLevelsRequest());
  try {
    const data = await ApiQuestion.fetchDifficultyLevels();
    dispatch(setQuestionDifficultyLevelsSuccess(data));
  } catch ({ message }) {
    dispatch(setQuestionDifficultyLevelsFailure({ message }));
  }
};
export const getQuestionDifficultyLevels = () => async (dispatch: Dispatch<any>, getState: any) => {
  const storeStates = getState();
  const { difficultyLevels } = storeStates.question;
  if (isEmpty(difficultyLevels.hits) && !difficultyLevels.isLoading) {
    dispatch(forceGetQuestionDifficultyLevels());
  }
};

export const forceGetQuestionFields = () => async (dispatch: Dispatch<any>) => {
  dispatch(setQuestionFieldsRequest());
  try {
    const data = await ApiQuestion.fetchFields();
    dispatch(setQuestionFieldsSuccess(data));
  } catch ({ message }) {
    dispatch(setQuestionFieldsFailure({ message }));
  }
};
export const getQuestionFields = () => async (dispatch: Dispatch<any>, getState: any) => {
  const storeStates = getState();
  const { fields } = storeStates.question;
  if (isEmpty(fields.hits) && !fields.isLoading) {
    dispatch(forceGetQuestionFields());
  }
};
